import { RouteConfig } from 'vue-router';
import ProfileLayout from '@/profile/components/ProfileLayout.vue';
import ProfileAccounts from '@/profile/pages/ProfileAccounts.vue';
import ProfileMyProfile from '@/profile/pages/ProfileMyProfile/ProfileMyProfile.vue';
import { sessionResolver } from '@/core/routing/resolvers/session';
import { profileRouteResolver } from '@/profile/routing/resolvers/profile-route-resolver';
import { profileMyProfileResolver } from '@/profile/routing/resolvers/profile-my-profile';
import { profileAccountsResolver } from '@/profile/routing/resolvers/profile-accounts';
import ProfileAddLinkedAccount from '@/profile/pages/ProfileAddLinkedAccount.vue';
import { profileAddLinkedAccountResolver } from '@/profile/routing/resolvers/profile-add-linked-account';
import { moduleRootRouteResolver } from '@/core/routing/resolvers/module-root-route-resolver';

export const ProfileRoutes: RouteConfig[] = [
	{
		path: '/profile',
		component: ProfileLayout,
		beforeEnter: moduleRootRouteResolver(),
		children: [
			{
				path: '',
				name: 'ProfileMyProfile',
				component: ProfileMyProfile,
				beforeEnter: profileRouteResolver(
					sessionResolver,
					profileMyProfileResolver,
				),
				meta: {
					pageTitle: 'My Profile',
				},
			},
			{
				path: 'accounts',
				name: 'ProfileAccounts',
				component: ProfileAccounts,
				beforeEnter: profileRouteResolver(
					sessionResolver,
					profileAccountsResolver,
				),
				meta: {
					pageTitle: 'My Accounts',
				},
			},
			{
				path: 'add-linked-account',
				name: 'ProfileAddLinkedAccount',
				component: ProfileAddLinkedAccount,
				beforeEnter: profileRouteResolver(
					sessionResolver,
					profileAddLinkedAccountResolver,
				),
				meta: {
					pageTitle: 'Add Linked Account',
				},
			},
		],
	},
];
